import { Droplets, Flame, Zap } from "lucide-react";

const AFFILIATE_URL = "https://bc072hg2p7rncg20qs5ev03po2.hop.clickbank.net";

export const HowItWorks = () => {
  const steps = [
    {
      number: "1",
      icon: <Droplets className="text-[#FF6B00]" size={32} />,
      title: "Take 1 Capsule",
      description: "Simply take one capsule each morning with a glass of water. That's it — no complicated routines.",
    },
    {
      number: "2", 
      icon: <Flame className="text-[#FF6B00]" size={32} />,
      title: "Activate Fat Burning",
      description: "The powerful citrus aurantium complex triggers thermogenesis — your body's natural fat-burning furnace.",
    },
    {
      number: "3",
      icon: <Zap className="text-[#FF6B00]" size={32} />,
      title: "Watch The Results",
      description: "Experience all-day energy, reduced cravings, and watch stubborn fat melt away week after week.",
    },
  ];

  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-16 md:py-20 bg-white" aria-labelledby="how-it-works-heading">
      <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" className="block">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 cursor-pointer">
          <div className="text-center mb-12">
            <span className="inline-block bg-[#FFF5E6] text-[#FF6B00] text-xs font-bold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
              Simple 3-Step Process
            </span>
            <h2 id="how-it-works-heading" className="text-3xl md:text-4xl lg:text-5xl font-black text-[#1A1C19] mb-4" style={{ fontFamily: "Fraunces, serif" }}>
              How The <span className="text-[#FF6B00]">"Orange Peel Trick"</span> Works
            </h2>
            <p className="text-lg text-[#4A5043] max-w-2xl mx-auto">
              No complicated diets. No exhausting workouts. Just one simple morning ritual.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
            {/* Connection Line */}
            <div className="hidden md:block absolute top-24 left-1/4 right-1/4 h-1 bg-gradient-to-r from-[#FF6B00] via-[#FFB347] to-[#FF6B00]" aria-hidden="true" />
            
            {steps.map((step, index) => (
              <div key={index} className="relative text-center hover:opacity-80 transition-opacity">
                {/* Step Number */}
                <div className="w-16 h-16 bg-gradient-to-r from-[#FF6B00] to-[#FF8C00] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg relative z-10" aria-hidden="true">
                  <span className="text-2xl font-black text-white">{step.number}</span>
                </div>
                
                {/* Icon */}
                <div className="w-20 h-20 bg-[#FFF5E6] rounded-2xl flex items-center justify-center mx-auto mb-4" aria-hidden="true">
                  {step.icon}
                </div>
                
                <h3 className="text-xl font-bold text-[#1A1C19] mb-3" style={{ fontFamily: "Fraunces, serif" }}>
                  {step.title}
                </h3>
                <p className="text-[#4A5043] leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </a>
    </section>
  );
};

export default HowItWorks;
